/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.GradeResponse = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The GradeResponse model module.
   * @module model/GradeResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>GradeResponse</code>.
   * The response for grade.
   * @alias module:model/GradeResponse
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>GradeResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GradeResponse} obj Optional instance to populate.
   * @return {module:model/GradeResponse} The populated <code>GradeResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('grade')) {
        obj['grade'] = ApiClient.convertToType(data['grade'], 'Number');
      }
      if (data.hasOwnProperty('elevationUnit')) {
        obj['elevationUnit'] = ApiClient.convertToType(data['elevationUnit'], 'String');
      }
      if (data.hasOwnProperty('wellKnownText')) {
        obj['wellKnownText'] = ApiClient.convertToType(data['wellKnownText'], 'String');
      }
      if (data.hasOwnProperty('startingElevation')) {
        obj['startingElevation'] = ApiClient.convertToType(data['startingElevation'], 'Number');
      }
      if (data.hasOwnProperty('endingElevation')) {
        obj['endingElevation'] = ApiClient.convertToType(data['endingElevation'], 'Number');
      }
    }
    return obj;
  }

  /**
   * The grade of the feature.
   * @member {Number} grade
   */
  exports.prototype['grade'] = undefined;
  /**
   * The unit of the elevation.
   * @member {String} elevationUnit
   */
  exports.prototype['elevationUnit'] = undefined;
  /**
   * The Well Known Text (WKT) of the feature.
   * @member {String} wellKnownText
   */
  exports.prototype['wellKnownText'] = undefined;
  /**
   * The starting elevation.
   * @member {Number} startingElevation
   */
  exports.prototype['startingElevation'] = undefined;
  /**
   * The ending elevation.
   * @member {Number} endingElevation
   */
  exports.prototype['endingElevation'] = undefined;



  return exports;
}));



